export const getVariantPropFromString = (variant) => {
  switch (variant) {
    case 'secondary':
      return { secondary: true };
    case 'dark':
      return { dark: true };
    case 'green':
      return { green: true };
    case 'outline':
      return { outline: true };
    case 'outlineWhite':
      return { outlineWhite: true };
    case 'outlineDark':
      return { outlineDark: true };
    case 'link':
      return { link: true };
    case 'standout':
      return { standout: true };
    case 'primary':
    default:
      return { primary: true };
  }
};

export const getVariantStringFromVar = ({
  primary,
  secondary,
  dark,
  green,
  outline,
  outlineWhite,
  outlineDark,
  outlineReadable,
  standout,
  link,
  wrapper,
}) => {
  switch (true) {
    case secondary:
      return 'secondary';
    case dark:
      return 'dark';
    case green:
      return 'green';
    case outline:
      return 'outline';
    case outlineWhite:
      return 'outlineWhite';
    case outlineDark:
      return 'outlineDark';
    case outlineReadable:
      return 'outlineReadable';
    case standout:
      return 'standout';
    case link:
      return 'link';
    case wrapper:
      return 'wrapper';
    case primary:
    default:
      return 'primary';
  }
};
